import { render } from "./rental_body_right.vue?vue&type=template&id=238ef482"
import script from "./rental_body_right.vue?vue&type=script&lang=js"
export * from "./rental_body_right.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__